import { Sequence } from '@cognite/sdk';

import { RelationshipLabels } from './resource';

export type SequenceWithRelationshipLabels = Sequence & RelationshipLabels;
